import request from "./request.service";

const getProfile = async (regNo) => {
  try {
    const result = await request(`/campaign/onchly/getprofile/${regNo}`, "GET");
    return result.data;
  } catch (err) {
    throw err;
  }
};
const getSections = async (profileId) => {
  try {
    const result = await request(
      `/campaign/onchly/api/v1/crm/profile/sections/${profileId}`,
      "GET"
    );
    return result.data;
  } catch (err) {
    throw err;
  }
};
const getSurveys = async (profileId) => {
  try {
    const result = await request(
      `/campaign/onchly/api/v1/crm/profile/surveys/${profileId}`,
      "GET"
    );
    return result.data;
  } catch (err) {
    throw err;
  }
};
const getUsers = async (profileId) => {
  try {
    const result = await request(
      `/campaign/onchly/api/v1/crm/profile/users/${profileId}`,
      "GET"
    );
    return result.data;
  } catch (err) {
    throw err;
  }
};
const getNotifications = async (profileId) => {
  try {
    const result = await request(
      `/campaign/onchly/api/v1/crm/profile/notifications/${profileId}`,
      "GET"
    );
    return result.data;
  } catch (err) {
    throw err;
  }
};
const getSegments = async (profileId) => {
  try {
    // const result = await request(
    //   `/campaign/onchly/api/v1/crm/profile/segments/${profileId}`,
    //   "GET"
    // );
    return result.data;
  } catch (err) {
    throw err;
  }
};

export default {
  getProfile,
  getSections,
  getSurveys,
  getUsers,
  getNotifications,
  getSegments,
};
